import { sortDate, sortString, sortNumber } from './sort';
import { stripHtml } from './stripHtml';
import { getColumnValue } from './getColumnValue';
import { translate } from '../Components/Translate';
import get from 'lodash/get';
import ConvertTableToCsvOptions from '../models/utils/ConvertTableToCsvOptions';
import GetChildColumnsOptions from '../models/utils/GetChildColumnsOptions';

export class CsvHelper {
    static convertTableToCsv(options: ConvertTableToCsvOptions) {
        const {
            config,
            columnConfig,
            shareClasses,
            locale,
            translations,
            headerDisclaimers,
            footerDisclaimers,
            dataStore,
        } = options;

        const fundCurrencyProperty = config.fundCurrencyProperty;
        const defaultNoDataPlaceholder = config.noDataPlaceholder;
        const workingShareClasses = [...(shareClasses || [])];
        const { sort, columns } = columnConfig;

        const headings: Array<any> = [];

        const workingFooterDisclaimers = this.escapeDisclaimers(
            footerDisclaimers
        );

        const workingHeaderDisclaimers = this.escapeDisclaimers(
            headerDisclaimers
        );

        if (sort && sort.type === 'date') {
            workingShareClasses.sort((a, b) =>
                sortDate(a[sort.key], b[sort.key])
            );
        }

        if (sort && sort.type === 'string') {
            workingShareClasses.sort((a, b) =>
                sortString(a[sort.key], b[sort.key])
            );
        }

        if (sort && sort.type === 'number') {
            workingShareClasses.sort((a, b) =>
                sortNumber(a[sort.key], b[sort.key])
            );
        }

        if (sort && sort.direction === 'DESC') {
            workingShareClasses.reverse();
        }

        const csv = workingShareClasses.map((shareClass, shareClassIndex) => {
            const fundCurrency = this.getFundCurrency(
                shareClass,
                fundCurrencyProperty
            );

            const columnValues: Array<string> = [];
            columns.forEach(column => {
                if (column.type === 'dropdown') {
                    for (const group of column.groups) {
                        this.getChildColumns({
                            dataStore,
                            shareClassIndex,
                            translations,
                            headings,
                            columnValues,
                            config,
                            shareClass,
                            locale,
                            fundCurrency,
                            defaultNoDataPlaceholder,
                            column: group,
                            childColumns: group.columns,
                        });
                    }
                } else if (column.type === 'group') {
                    this.getChildColumns({
                        dataStore,
                        column,
                        shareClassIndex,
                        translations,
                        headings,
                        columnValues,
                        config,
                        shareClass,
                        locale,
                        fundCurrency,
                        defaultNoDataPlaceholder,
                        childColumns: column.columns,
                    });
                } else if (!column.type) {
                    if (shareClassIndex === 0) {
                        headings.push(translate(translations, column.label));
                    }
                    columnValues.push(
                        getColumnValue({
                            config,
                            column,
                            shareClass,
                            locale,
                            fundCurrency,
                            defaultNoDataPlaceholder,
                            translations,
                            dataStore,
                        })
                    );
                }
            });
            return columnValues.map(this.escapeValue).join(',');
        });
        csv.unshift(headings.map(this.escapeValue).join(','));
        if (workingHeaderDisclaimers && workingHeaderDisclaimers.length > 0) {
            csv.unshift(workingHeaderDisclaimers);
        }
        csv.push(workingFooterDisclaimers);
        return csv.join('\n');
    }

    static getChildColumns(options: GetChildColumnsOptions) {
        const {
            dataStore,
            column,
            childColumns,
            shareClassIndex,
            translations,
            headings,
            columnValues,
            config,
            shareClass,
            locale,
            fundCurrency,
            defaultNoDataPlaceholder,
        } = options;
        for (const childColumn of childColumns) {
            if (shareClassIndex === 0) {
                const childColumnHeadingParts: Array<string> = [
                    translate(translations, column.label),
                    translate(translations, childColumn.label),
                ];
                headings.push(childColumnHeadingParts.join(' - '));
            }
            columnValues.push(
                getColumnValue({
                    dataStore,
                    config,
                    shareClass,
                    locale,
                    fundCurrency,
                    defaultNoDataPlaceholder,
                    translations,
                    column: childColumn,
                })
            );
        }
    }

    static escapeValue(value) {
        let response = value;
        if (response && response.includes && response.includes('"')) {
            response = response.split('"').join('""');
        }
        return `"${response}"`;
    }

    static escapeDisclaimers(disclaimers?: Array<any>) {
        return (disclaimers || []).map(d => `"${stripHtml(d)}"`).join('\n');
    }

    static getFundCurrency(shareClass, fundCurrencyProperty) {
        return get(
            shareClass,
            `properties_pub.${fundCurrencyProperty || 'ccy'}.value`
        );
    }
}



// WEBPACK FOOTER //
// ./src/utils/CsvHelper.ts